export default __webpack_public_path__ + "static/enterprises.url-725cc4788d0135fd7d05471c1da1f5c9.svg";